import { UserService } from './user.service';

export const AllServices = [UserService];
